import { FC } from "react";

interface IDataFieldProps {
  label: string;
  value: string;
}

const DataField: FC<IDataFieldProps> = ({ label, value }) => {
  return (
    <div className="border rounded-lg border-black px-4 py-2">
      <h1 className="font-bold text-lg">{label}</h1>
      <p className="text-black">{value}</p>
    </div>
  );
};

export default DataField;
